import { defineStore } from 'pinia';

export const useDeliveryStore = defineStore('deliveryStore', {
    state: () => ({
        selectedVehicle: 'pickup',

        vehicles: [
            {
                id: 'pickup',
                title: 'Пикап / каблук',
                capacity: 'Небольшой объём',
                freePickup: true,
                shortDescription: 'Для небольших партий цветного металла, кабеля, аккумуляторов и компактного лома.',
                description: 'Подходит для небольших партий металлолома, когда нужен быстрый и аккуратный вывоз без крупной техники. Обычно используется для кабеля, аккумуляторов, цветного металла, небольших двигателей, радиаторов и другого компактного лома.',
                bestFor: 'Небольшие партии лома',
                loading: 'Ручная / частично ручная',
                useCases: 'Частные адреса, гаражи, склады',
                restrictions: 'Не подходит для тяжёлых и крупногабаритных конструкций',
                items: [
                    'Кабель',
                    'Аккумуляторы',
                    'Медь',
                    'Алюминий',
                    'Латунь',
                    'Радиаторы',
                    'Небольшие электродвигатели'
                ],
                advantages: [
                    'Быстрый выезд на небольшие объёмы',
                    'Удобен для частных клиентов и небольших объектов',
                    'Подходит там, где крупная машина не проедет',
                    'Хороший вариант для цветного металла и компактного лома'
                ]
            },

            {
                id: 'gazelle',
                title: 'Газель',
                capacity: 'Малый / средний объём',
                freePickup: true,
                shortDescription: 'Универсальный вариант для гаражей, частных объектов, небольших демонтажей и mixed-лома.',
                description: 'Газель — универсальный транспорт для вывоза металлолома средних объёмов. Подходит для выезда на частные адреса, в гаражи, на склады, небольшие стройплощадки и после локального демонтажа. Часто используется, когда объём уже больше легкового вывоза, но ещё не нужен ломовоз.',
                bestFor: 'Средние объёмы и смешанный лом',
                loading: 'Ручная / с помощью грузчиков',
                useCases: 'Гаражи, склады, частные дома, небольшие объекты',
                restrictions: 'Не лучший вариант для очень тяжёлого или навального объёма',
                items: [
                    'Чермет',
                    'Цветмет',
                    'Профиль',
                    'Трубы',
                    'Кабель',
                    'Бытовой металлический лом',
                    'Металлоконструкции малого объёма'
                ],
                advantages: [
                    'Универсальный формат для большинства заявок',
                    'Удобна для частных и коммерческих адресов',
                    'Подходит для умеренных объёмов металлолома',
                    'Быстрый и понятный вариант для стандартного вывоза'
                ]
            },

            {
                id: 'lomovoz',
                title: 'Ломовоз',
                capacity: 'Крупный объём',
                freePickup: true,
                shortDescription: 'Для большого объёма чёрного металла, производственного лома и постоянного накопления.',
                description: 'Ломовоз используется для крупных объёмов металлолома, особенно чёрного. Это лучший вариант для производств, складов, баз, демонтажных работ и объектов, где накапливается много тяжёлого и навального металла.',
                bestFor: 'Большие объёмы чёрного металла',
                loading: 'Механизированная / навальная',
                useCases: 'Производства, базы, стройплощадки, демонтаж',
                restrictions: 'Нужен нормальный подъезд и место для работы крупной техники',
                items: [
                    'Черный металлолом',
                    'Толстый металл',
                    'Арматура',
                    'Балка',
                    'Швеллер',
                    'Листовой металл',
                    'Производственный лом'
                ],
                advantages: [
                    'Один из лучших вариантов для большого объёма',
                    'Подходит для тяжёлого и навального лома',
                    'Удобен для предприятий и строительных объектов',
                    'Снижает количество рейсов при крупном вывозе'
                ]
            },

            {
                id: 'manipulator',
                title: 'Манипулятор',
                capacity: 'Тяжёлый и габаритный лом',
                freePickup: true,
                shortDescription: 'Для тяжёлых конструкций, оборудования, трансформаторов, станков, балок и узлов.',
                description: 'Манипулятор нужен там, где металл нельзя просто загрузить вручную. Он подходит для тяжёлых и габаритных металлоконструкций, станков, трансформаторов, электродвигателей, балок, плит и других массивных элементов. Особенно полезен, когда на объекте нет своей погрузочной техники.',
                bestFor: 'Тяжёлые и крупногабаритные позиции',
                loading: 'Самостоятельная погрузка стрелой',
                useCases: 'Промышленные объекты, демонтаж, крупные частные и коммерческие адреса',
                restrictions: 'Нужна зона для работы стрелы и безопасный подъезд',
                items: [
                    'Трансформаторы',
                    'Электродвигатели',
                    'Станки',
                    'Балка',
                    'Швеллер',
                    'Металлоконструкции',
                    'Тяжёлое оборудование'
                ],
                advantages: [
                    'Не нужна отдельная погрузочная техника на объекте',
                    'Удобен для тяжёлых и неудобных по форме изделий',
                    'Подходит для демонтажных и промышленных задач',
                    'Ускоряет вывоз массивных металлоконструкций'
                ]
            },

            {
                id: 'container',
                title: 'Контейнер',
                capacity: 'Для накопления лома',
                freePickup: true,
                shortDescription: 'Для объектов, где металлолом накапливается постепенно и нужен регулярный вывоз.',
                description: 'Контейнер удобен для предприятий, строительных площадок, складов и промышленных объектов, где лом образуется постоянно. Мы устанавливаем контейнер, вы накапливаете металл, а затем организуется вывоз заполненного объёма.',
                bestFor: 'Регулярное накопление и крупные объёмы',
                loading: 'Постепенное накопление в контейнер',
                useCases: 'Производство, стройка, склады, долгосрочные объекты',
                restrictions: 'Нужно место под установку контейнера и подъезд техники',
                items: [
                    'Чермет',
                    'Производственный лом',
                    'Обрезь',
                    'Стружка',
                    'Металлоконструкции',
                    'Складской лом',
                    'Строительный лом'
                ],
                advantages: [
                    'Удобен для постоянного накопления металлолома',
                    'Снижает хаос на объекте и упрощает сбор',
                    'Подходит для длительных проектов и предприятий',
                    'Хороший вариант для регулярного вывоза'
                ]
            }
        ],

        acceptedCategories: [
            'Черный металлолом',
            'Цветной металл',
            'Кабель',
            'Аккумуляторы',
            'Электродвигатели',
            'Трансформаторы',
            'Стружка',
            'Нержавейка',
            'Латунь',
            'Алюминий',
            'Медь',
            'Металлоконструкции'
        ],

        faq: [
            {
                question: 'Вывоз точно бесплатный?',
                answer: 'Да, вывоз у нас бесплатный. Мы не делаем отдельную оплату за подачу машины — транспорт подбирается под ваш объём и формат металлолома.'
            },
            {
                question: 'Как понять, какая машина нужна?',
                answer: 'Обычно достаточно отправить фото, адрес и примерный объём. Мы сами определим, что лучше подойдёт: газель, ломовоз, манипулятор или контейнер.'
            },
            {
                question: 'Можно ли вывезти тяжёлые металлоконструкции?',
                answer: 'Да, для этого обычно используется манипулятор или другой спецтранспорт. Всё зависит от размеров, веса и условий на адресе.'
            },
            {
                question: 'Вы вывозите лом с частных адресов?',
                answer: 'Да, мы работаем как с частными клиентами, так и с организациями, складами, производствами и строительными объектами.'
            },
            {
                question: 'Что нужно для быстрого согласования?',
                answer: 'Лучше всего сразу отправить фото металла, примерный объём, адрес и уточнить, нужна ли погрузка или демонтаж.'
            },
            {
                question: 'Можно ли поставить контейнер на объект?',
                answer: 'Да, если на объекте регулярно накапливается лом, контейнер — один из самых удобных вариантов для последующего вывоза.'
            }
        ]
    }),

    getters: {
        currentVehicle(state) {
            return state.vehicles.find(v => v.id === state.selectedVehicle) || state.vehicles[0];
        }
    },

    actions: {
        setVehicle(vehicleId) {
            this.selectedVehicle = vehicleId;
        }
    }
});
